export default __webpack_public_path__ + "static/media/sideNavInner.a96afb42.png";